import {collection, query, where} from "firebase/firestore";
import {fire} from "../../fire";
import {obtenerColeccionQuery} from "../../Servicios/BD/obtenerColeccionQuery";

export const buscarReservacionesDiaHora = async ({fechaInicio, fechaFin}) => {


    let wheres = [where('fechaInicio', '>=', fechaInicio), where('fechaFin', '<=', fechaFin)]

    let q = query(collection(fire, 'reservaciones'), ...wheres)

    let dox = await obtenerColeccionQuery(q)
    if (dox.res && dox.data && dox.data.length) {
        return dox.data
    } else {
        return []
    }

}